import React from 'react'

export class Icon extends React.Component {
  render() {
    const { type, className } = this.props
    return <>{React.createElement(type, { className: className })}</>
  }
}

export default Icon
